<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <b-spinner
                    class="spinner"
                    key="info"
                    variant="info"
            ></b-spinner>
        </div>
        <div class="text-center">
            <strong class="loading">{{titles.loading}}</strong>
        </div>
    </div>
</template>

<script>
    import {titles} from '../../utils/general/titles';

    export default {
        name: 'Loading',
        data() {
            return {
                titles
            };
        }
    };
</script>

<style scoped>
    @import '../../assets/style/css/base.css';
</style>